/** Strategem 324 (Forbidden Clone Protocol): fade-in target art on sacrificed unit */
export const FLESHSACK_TARGET_IMAGE_PATH = '/images/fleshsack_target.png';
export const FLESHSACK_SOUND_PATH = '/sounds/fleshsack.mp3';
export const FLESHSACK_TARGET_FADE_DURATION_MS = 720;
